"use client";

import { Button } from "@mui/material";
import { useEditDialog } from "../Providers/EditDialogContext";

export default function CancelButton() {
  const { closeEditDialog } = useEditDialog();

  return (
    <Button onClick={closeEditDialog} type="button">
      Cancel
    </Button>
  );
}
